import { useState, useEffect } from 'react';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      // Check for actual mobile devices (phones), not just touch support
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;
      
      // Exclude tablets (iPad, Android tablets with large screens)
      const isTablet = /iPad|Android/i.test(userAgent) && window.innerWidth > 768;
      
      setIsMobile(mobileRegex.test(userAgent) && !isTablet);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile;
}